import { isEmptyObject, getGlobal, getQueryParam, isString, stringifyError, isFunction } from '../helpers';
import { ToolComponent } from '../shared/ToolComponent';
import { LeafComponentFactory } from '../shared/componentdef-factory';
import { ZalgoPromise } from 'zalgo-promise';

/**
 * Creates a child component
 * @param {String} componentName 
 * @param {*} param1 
 * @returns {ZoidComponent}
 */
export function createComponent(componentName, {
    tag,
    url,
    domain,
    bridgeUrl,
    method,
    props,
    dimensions,
    autoResize,
    attributes,
    template = null,
    defaultContext
}) {
    return LeafComponentFactory(componentName, template, {
        tag,
        url,
        domain,
        bridgeUrl,
        method,
        props,
        dimensions,
        autoResize,
        attributes,
        defaultContext
    });
}

/**
 * Integrates tool into host site.
 * @returns {Promise}
 */
export function integrate({
    toolName,
    companyCode,
    lang,
    version,
    resizeElement = 'body',
    allowedParentDomains = '*'
}) {
    const global = getGlobal();

    if (global.initialized === true) {
        return;
    }

    const getToolNameFromUrl = () => {
        const url = location.pathname; // pathname look like: /tools/sharegraph/?query=xxx
        if (url.match(/^\/tools\//i)) {
            const segments = url.split('/');
            if (segments.length >= 3) {
                return segments[2];
            }
        }
        return null;
    };

    const getCompanyCodeFromUrl = () => {
        return getQueryParam('companycode');
    };

    const getLanguageFromUrl = () => {
        return getQueryParam('lang');
    };

    const getVersionFromUrl = () => {
        return getQueryParam('v');
    };
    
    if (!isString(toolName) || toolName.length === 0) {
        //throw new Error('')
    }

    let toolComponentReady = false;
    
    const initToolComponent = () => {
        if (toolComponentReady) {
            return ZalgoPromise.resolve(true);
        }
        else {
            return new ZalgoPromise(resolve => {
                ToolComponent({
                    toolName: toolName || getToolNameFromUrl(),
                    companyCode: companyCode || getCompanyCodeFromUrl(),
                    lang: lang || getLanguageFromUrl(),
                    toolVer: version || getVersionFromUrl(),
                    resizeElement: resizeElement || 'body',
                    allowedParentDomains: allowedParentDomains || '*'
                });
                toolComponentReady = true;
                resolve(true);
            });
        }
    };

    const pushComponents = () => {
        return new ZalgoPromise(resolve => {
            for (var name in global.components) {
                if (({}).hasOwnProperty.call(global.components, name)
                    && !isEmptyObject(global.components[name].componentOptions)
                    && window.xprops
                    && isFunction(window.xprops.onCreateComponent)
                ) {
                    window.xprops.onCreateComponent({
                        props: {
                            componentName: name,
                            template: global.components[name].containerTemplate,
                            options: global.components[name].componentOptions
                        }
                    });
                }
            }

            resolve();
        });
    };

    return ZalgoPromise.all([initToolComponent(), pushComponents()])
        .then(() => {
            global.initialized = true;
        }).catch(err => {
            console.error(`Prolem occurred when trying to integrate tool with parent site. Err: ${stringifyError(err)}`);
            throw err;
        });
}